var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h4',{staticClass:"title is-4"},[_vm._v("Events")]),_c('app-events-filters',{attrs:{"preselected":_vm.filters,"onSubmit":_vm.handleSubmit}}),_c('app-events-log-list',{attrs:{"data":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }